import ContratoInterceptor from '../ContratoInterceptor'

const api = new ContratoInterceptor()

export default {
  getFontesPagadoras() {
    return api.get('/fontes-pagadoras')
  },

  getFontesPagadorasByUserId(userId: String, plantao: boolean = false) {
    return api.get(`/fontes-pagadoras/${userId}?plantao=${plantao}`)
  },
}